import s from './Title.module.scss';
import {TTitleProps} from "@/app/[locale]/common/components/Title/types";
import {Label} from "@/app/[locale]/common/components/Label/Label";
import {Line} from "@/app/[locale]/common/components/Line/Line";

export const Title = ({ title, className }: TTitleProps) => {
    return (
        <div className={`${s.title} ${className ? className : ''}`}>
            <Label>{ title }</Label>
            <Line className={s.title_line}/>
        </div>
    );
};